import styles from './signin/signin.module.css';

/** The logo mark + wordmark every auth page opens with. */
export function AuthBrand() {
  return (
    <div className={styles.header}>
      <div className={styles.brandRow}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src="/assets/photonium-logo.svg" alt="" width={38} height={35} className={styles.logoMark} />
        <h1 className={styles.logoText}>Photonium Insight</h1>
      </div>
    </div>
  );
}
